export var createCommencedEvent = function createCommencedEvent(fileId, traceContext) {
  return {
    eventType: 'operational',
    action: 'commenced',
    actionSubject: 'mediaFile',
    attributes: {
      fileAttributes: {
        fileId: fileId
      },
      traceContext: traceContext
    }
  };
};